'use client'

import SvgIcon from '@mui/material/SvgIcon'
import PropTypes from 'prop-types'

export const NumbersIcon = ({ sx }) => {
  return (
    <SvgIcon sx={sx} data-testid="NumbersIcon">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        id="Number--Streamline-Ultimate"
        height="24"
        width="24"
      >
        <desc>Number Streamline Icon: https://streamlinehq.com</desc>
        <path
          stroke="#3d517b"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="m12.6558 1.36719 0 8.68681"
          strokeWidth="1"
        ></path>
        <path
          stroke="#3d517b"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="m9.76017 3.53888 0.72393 0c1.1994 0 2.1717 -0.9723 2.1717 -2.17169v0"
          strokeWidth="1"
        ></path>
        <path
          stroke="#3d517b"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M15.5488 10.0537H9.75764"
          strokeWidth="1"
        ></path>
        <path
          stroke="#3d517b"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M15.5508 21.1848c0.2981 0.8435 1.1025 1.4478 2.0481 1.4478l1.4478 0c1.1994 0 2.1717 -0.9723 2.1717 -2.1717l0 -0.3619c0 -1.1994 -0.9723 -2.1717 -2.1717 -2.1717l-0.7239 -0.0001h0.5429c1.0995 0 1.9908 -0.8912 1.9908 -1.9907 0 -1.0994 -0.8913 -1.9907 -1.9908 -1.9907l-1.0858 0c-0.9112 0 -1.6795 0.6122 -1.9158 1.4478"
          strokeWidth="1"
        ></path>
        <path
          stroke="#3d517b"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M8.57244 22.6326H2.78125v-1.234c0 -0.8628 0.51077 -1.6438 1.30124 -1.9896l3.22247 -1.4098c0.76996 -0.3369 1.26748 -1.0976 1.26748 -1.938 0 -1.1683 -0.94708 -2.1154 -2.11536 -2.1154H4.95295c-0.94557 0 -1.75 0.6043 -2.04813 1.4478"
          strokeWidth="1"
        ></path>
      </svg>
    </SvgIcon>
  )
}

NumbersIcon.propTypes = {
  sx: PropTypes.object
}
